import React from "react";
import {useTranslation} from "react-i18next";
import {useHistory, useLocation} from "react-router-dom";

import {
    formatDate,
    MOMENT_FORMAT_DATE_DMYHM_DOTS,
} from "../../../../functions/formatters";
import {contractRequestCRUD, filialDivisionCRUD} from "../../../../http/CRUD";
import {
    CONTRACT_REQUEST,
    CONTRACT_REQUEST_CREATE,
} from "../../../../routes/const";
import {EnhancedCRUDTable} from "../../EnhancedCRUDTable";
import CRUDTable from "../../CRUDTable";
import {getProtocolForms} from "../../../../redux/actions/protocolFormActions";
import {getDepartments, getDivisions, getFilials} from "../../../../redux/actions";
import {actsSearchFields} from "../../../../sections/Filters/ActsFilters";
import {
    contractRequestClientFilterFields,
} from "../../../../sections/Filters/ContractRequestFilter";
import {getRequestStates} from "../../../../redux/actions/requestStateActions";

export const ContractRequestCRUDTable = ({ extraQuery: extraQueryProp, ...props }) => {
    const {t} = useTranslation();
    const {push} = useHistory();
    const {pathname} = useLocation();

    const columns = [
        {title: t("request.tableItem.id"), dataIndex: "id", key: "id"},
        {
            title: t("request.tableItem.number"),
            dataIndex: "number",
            key: "number",
        },
        {
            title: t("request.tableItem.contractId"),
            dataIndex: "contractNumber",
            key: "contractNumber",
            render: (value, row) => value || row?.contract?.number || "-",
        },
        {
            title: t("request.tableItem.status"),
            dataIndex: "state",
            key: "state",
            render: (row) => row?.name || "-",
        },
        {
            title: t("request.tableItem.createdBy"),
            dataIndex: "createdBy",
            key: "createdBy",
            render: (row) => row?.fullName || "-",
        },
        {
            title: 'Наименование клиента',
            dataIndex: "client",
            key: "client",
            render: (row) => row?.legalPerson ? row.legalPerson?.name : row?.person ? row.person?.fullName : "-",
        },
        {
            title: 'Исполнитель заявки',
            dataIndex: "performer",
            key: "performer",
            render: (row) => row?.fullName || "-",
        },
        {
            title: t("request.tableItem.createdAt"),
            dataIndex: "createdAt",
            key: "createdAt",
            render: (row) => formatDate(row, MOMENT_FORMAT_DATE_DMYHM_DOTS) || "-",
        },
        {
            dataIndex: "filial",
            key: "filial",
            title: "Филиал",
            render: (unknown, row) => {
                return row.filial?.name
            }
        },
        {
            dataIndex: "filialBIN",
            key: "filialBIN",
            title: "БИН филиала",
            render: (unknown, row) => {
                return row.filial?.bin
            }
        },
        {
            dataIndex: "filialDivision",
            key: "filialDivision",
            title: "Районное отделение",
            render: (unknown, row) => {
                return row.filialDivision?.name
            }
        },
        {
            dataIndex: "filialDivisionBIN",
            key: "filialDivisionBIN",
            title: "БИН районного отделения",
            render: (unknown, row) => {
                return row.filialDivision?.bin
            }
        },
    ];

    const searchFields = [
        ...actsSearchFields,
        {
            title: "БИН филиала",
            key: "filialBIN",
            key1: "filial",
            key2: "BIN",
            compareType: "like",
            operandPosition: 1,
            filterType: "normal",
        },
        {
            title: "БИН районного отделения",
            key: "filialDivisionBIN",
            key1: "filialDivision",
            key2: "BIN",
            compareType: "like",
            operandPosition: 1,
            filterType: "normal",
        },
    ];

    const filterFields = [
        {
        title: "Cтатус",
        key: "stateId",
        compareType: "equals",
        reducerKey: "requestState",
        reducerArrayKey: "requestStates",
        reducerAction: getRequestStates,
        operandPosition: 1,
        optionLabelKey: "name",
        type: "normal",
        filterType: "normal",
    },
        {
            title: "Филиал",
            key: "filialId",
            compareType: "equals",
            reducerKey: "filial",
            reducerArrayKey: "filials",
            reducerAction: getFilials,
            operandPosition: 1,
            optionLabelKey: "name",
            type: "normal",
            filterType: "normal",
        },
        {
            title: "Районное отделение",
            key: "filialDivisionId",
            compareType: "equals",
            reducerKey: "filialDivision",
            operandPosition: 1,
            parentKey: 'filialId',
            optionLabelKey: "name",
            type: "normal",
            filterType: "normal",
            useDomainSelect2: true,
            domainSelectCrud: filialDivisionCRUD,
            domainSelect2SkipFetchWithoutParent: true,
            domainSelect2NoParentHint: "Выберите филиал",
            selectMembers: ["Id", "Name", "FilialId"],
            normalizeOption: (row) => ({
                ...row,
                id: row.id ?? row.Id,
                name: row.name ?? row.Name,
                filialId: row.filialId ?? row.FilialId,
            }),
        },
        ...contractRequestClientFilterFields,
    ];

    const mergedExtraQuery = {
        ...(extraQueryProp || {}),
        includes: [
            ...new Set([
                "Filial",
                "FilialDivision",
                ...((extraQueryProp && extraQueryProp.includes) || []),
            ]),
        ],
    };

    return (
        <CRUDTable
            searchFields={searchFields}
            filterFields={filterFields}
            search={contractRequestCRUD.search}
            extraQuery={mergedExtraQuery}
            columns={columns}
            onClickDetailsButton={(id) => {
                push(`${pathname}/${id}`)
            }}
            rowClassNameHandler={(record) => {
                if (record.state?.code === "Declined") {
                    return 'banned'
                }
            }}
            {...props}
        />
    );
};
